var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6976 35.6976L18.2443 32.6437L18 32.5069L17.7557 32.6437L12.3024 35.6976L15.3563 30.2443L15.4931 30L15.3563 29.7557L12.3024 24.3024L17.7557 27.3563L18 27.4931L18.2443 27.3563L23.6976 24.3024L20.6437 29.7557L20.5069 30L20.6437 30.2443L23.6976 35.6976Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40171 84.5455L7.92381 85.0676L8.41681 84.5179L58.7857 28.361L57.7982 27.3734L1.64122 77.7423L1.09157 78.2353L1.61366 78.7574L7.40171 84.5455Z",
    stroke: "white",
    strokeWidth: 1.39865
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3984 60.5312H29.3984",
    stroke: "white",
    strokeWidth: 1.39865
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7559 43.7559L74.0709 49.0253L78.2528 53.2072L72.4116 52.282L69.7266 57.5515L68.8015 51.7103L62.9602 50.7851L68.2297 48.1002L67.3045 42.2589L71.4864 46.4408L76.7559 43.7559Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2336 8.23796L71.344 15.0529L78.1588 15.1632L72.3122 18.6663L75.624 24.6234L69.6669 21.3115L66.1639 27.1582L66.0535 20.3433L59.2386 20.2329L65.0853 16.7299L61.7734 10.7728L67.7305 14.0846L71.2336 8.23796Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.34ba48470a520bcf31cb35f0171a17dc.svg";
export { ForwardRef as ReactComponent };